import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewReportSetting = ({ report }) => {
  if (!report) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Report Setting Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            MsrsReport: {report.msrsReport}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Description: {report.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Individual Order: {report.individualOrder ? 'Yes' : 'No'}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Parameter Prompts: {report.parameterPrompts ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Report Type: {report.reportType}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Update Order Status: {report.updateorderstatus ? 'Yes' : 'No'}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Label Report: {report.labelreport ? 'Yes' : 'No'}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewReportSetting;
